<template>
  <main>
    <div class="main-green-font main-schedule-date-button-group">{{year}}年{{month + 1}}月</div>
    <div class="monthly-row">
      <div class="monthly-title-box monthly-green-font" v-for="weekName in weekNames" :key='weekName'>{{weekName}}</div>
    </div>
    <div class="monthly-row" v-for="week in weeks" v-bind:key="week.days[0].day.getTime()">
      <div class="monthly-each-day-box" style="min-height: 80px;" v-for="day in week.days" v-bind:key="day.day.getTime()">
        <div class="monthly-svg-date">
          <div v-if="day.isToday" class="monthly-today">{{day.day.getDate()}}</div>
          <div v-else-if="day.isThisMonth" class="monthly-green-font">{{day.day.getDate()}}</div>
          <div v-else class="monthly-grey-font">{{day.day.getDate()}}</div>
        </div>
        <div v-if="isMobile" @click="goToDate(day.day)">
          <div v-if="day.missions.list.length > 0">
            <eva-icon name="star"></eva-icon>
          </div>
        </div>
        <div v-else class="monthly-each-day-mission">
          <div class="monthly-box-content" v-for="mission in day.missions.list" :key="'' + mission.id + day.day.getTime()">
            <!-- <div>{{mission.name}}</div> -->
            <router-link :to="{
            name: 'ClassActivity',
            query: mission.query
            }">{{ mission.shortName }}</router-link>
          </div>
          <div v-if="day.missions.hvMore" @click="goToDate(day.day)" style="color: green; cursor: pointer;">查看更多...</div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
  .monthly-light-green-font{
    color: #99CB32;
    font-size: 1rem;
  }
  .monthly-row{
    display:flex;
  }
  .monthly-red-font{
    color: red;
    font-size: 1rem;
  }
  .monthly-green-font{
    color: #387E1E;
    font-size: 1rem;
  }
  .monthly-finish{
    color: #878A8B;
  }
  .monthly-expected-time{
    position:absolute;
    right:0.5rem;
    bottom:0.2rem;
  }
  .monthly-grey-font{
    color: #878A8B;
    font-size: 1rem;
  }
  .monthly-today{
    background-color: #99CB32;
    color: #FFF;
    font-size: 1.2rem;
    line-height: 1.2rem;
    border-radius: 1.2rem;
    width: 1.2rem;
    height: 1.2rem;
    text-align: center;
  }
  .monthly-unfinish{
    color: #387E1E;
  }
  .monthly-each-day-box{
    position:relative;
    margin: 0.2rem;
    padding : 0.2rem;
    border-radius: 0.8rem;
    border: 1px solid #99CB32;
    display:flex;
    width:100%;
  }
  .monthly-title-box{
    position:relative;
    margin: 0.2rem;
    padding : 0.2rem;
    border-radius: 0.8rem;
    display:flex;
    justify-content: center;
    width:100%;
  }
  .monthly-each-day-mission{
    font-size: 1rem;
    padding: 0 5px;
  }
  .monthly-each-row{
    height: 1rem;
  }
  @media screen and (max-width: 790px) {
    main{
      width: calc( 100vw - var(--app-padding) - var(--app-padding) );
    }
    .monthly-each-day-box{
      display: block;
    }
  }
</style>
<script>
import { EvaIcon } from 'vue-eva-icons'
var moment = require('moment')
export default {
  components: {
    [EvaIcon.name]: EvaIcon
  },
  props: {
    year: Number,
    month: Number,
    date: Number
  },
  data () {
    return {
      weekNames: ['日', '一', '二', '三', '四', '五', '六'],
      // missions: []
      today: new Date(),
      missions: []
    }
  },
  computed: {
    cDay: function () {
      if (this.year !== null && this.month !== null && this.date !== null) {
        return new Date(this.year, this.month, this.date)
      } else {
        return new Date()
      }
    },
    dayOfMonth: function () {
      var d = new Date(this.cDay)
      d.setDate(1)
      d.setMonth(d.getMonth() + 1)
      return (new Date(d.getTime() - 86400000)).getDate()
    },
    firstDay: function () {
      var day = this.cDay.getDate() - this.cDay.getDay()
      var noOfWeek = Math.ceil(day / 7)
      let firstDay = new Date(this.cDay.getTime() - (noOfWeek * 7 + this.cDay.getDay()) * 86400000)
      console.log('firstDay', firstDay)
      return firstDay
    },
    endDay: function () {
      var day = this.cDay.getDate() + 6 - this.cDay.getDay()
      var noOfWeek = Math.ceil((this.dayOfMonth - day) / 7)
      let endDay = new Date(this.cDay.getTime() + (noOfWeek * 7 + 7 - this.cDay.getDay()) * 86400000)
      console.log('endDay', endDay)
      return endDay
    },
    weeks: function (month) {
      var weeks = []
      var days = []
      var day = new Date(this.firstDay)
      while (true) {
        let missionList = this.missions.filter(mission => {
          return moment(day).format('YYYY-MM-DD') === moment(mission.endDatetime).format('YYYY-MM-DD')
        }).map(mission => {
          if (mission.name.length > 8) {
            mission.shortName = mission.name.substr(0, 8) + '...'
          } else {
            mission.shortName = mission.name
          }
          return mission
        })
        let _day = new Date(day)
        let dayObject = {
          day: _day,
          missions: {
            list: missionList.slice(0, 2),
            hvMore: missionList.length > 0
          },
          isToday: _day.getDate() === this.today.getDate() && _day.getMonth() === this.today.getMonth() && _day.getFullYear() === this.today.getFullYear(),
          isThisMonth: _day.getMonth() === this.today.getMonth()
        }
        days.push(dayObject)
        if (day.getDay() === 6) {
          var week = {
            days: days
          }
          weeks.push(week)
          days = []
        }
        day.setTime(day.getTime() + 86400000)
        if (day > this.endDay) break
      }
      return weeks
    },
    isMobile: function () {
      return window.screen.width < 790
    }
  },
  methods: {
    getMore: function (e) {
      let day = new Date(parseInt(e.target.getAttribute('time')))
      this.$router.push({
        name: 'HomeDaily',
        query: {
          year: day.getFullYear(),
          month: day.getMonth(),
          date: day.getDate()
        }
      })
    },
    goToDate: function (date) {
      // console.log(date)
      console.log(this.$parent)
      this.$parent.initYear = date.getFullYear()
      this.$parent.initMonth = date.getMonth()
      this.$parent.initDate = date.getDate()
      this.$parent.switchDaily()
      // console.log(this)
      // this.$router.push({
      //   query: {
      //     year: date.getFullYear(),
      //     month: date.getMonth(),
      //     date: date.getDate()
      //   }
      // })
    }
  },
  async mounted () {
    console.log('here is monthly')
    this.$emit('loading')
    let res = await this.$store.dispatch('request', {
      route: `activities?start=${this.firstDay.getFullYear()}-${this.firstDay.getMonth() + 1}-${this.firstDay.getDate()}&end=${this.endDay.getFullYear()}-${this.endDay.getMonth() + 1}-${this.endDay.getDate()}&type=weeks`
    })
    this.missions = res.activities
    console.log(this.$store.getters.isStudent)
    console.log(this.$store.getters.isTeacher)
    if (this.$store.getters.isStudent) {
      this.missions = this.missions.filter(act => new Date() > new Date(act.startDatetime))
      console.log(this.missions.filter(act => new Date() > new Date(act.startDatetime)))
    }
    // console.log(this.$store.getters.isTeacher)
    // console.log(this.missions.map(act => new Date(act.startDatetime)))
    this.$emit('loaded')
  }
}
</script>
